import React from 'react';

import { InputOption, CheckOption } from '../components/InputOption';

type Props = {
  name: string;
  checked: boolean;
  label?: string;
  helpText?: string;
  hasError?: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
};

const RawCheckbox = ({
  name,
  checked,
  label,
  helpText,
  hasError = false,
  disabled = false,
  onChange,
}: Props) => (
  <InputOption disabled={disabled} label={label} helpText={helpText}>
    <CheckOption
      name={name}
      isSelected={checked}
      checked={checked}
      onChange={event => onChange(event.target.checked)}
      hasError={hasError}
      disabled={disabled}
    />
  </InputOption>
);

export { RawCheckbox };
